import axios from "axios";
import { GET_SMS_LIST } from "../constant";
import smslist from "../data/smslist.json";
import Moment from "moment";
const { decorate, observable, action } = require("mobx");
const today = Moment().format("YYYY-MM-DD");

class Sms {
  list = [];
  startDt = today;
  endDt = today;
  blocking = false;

  // async getSmsList(startDt, endDt) {
  //   try {
  //     this.blocking = true;
  //     let response = await axios.post(GET_SMS_LIST, {
  //       startDt: startDt,
  //       endDt: endDt,
  //     });
  //     this.list = await response.data;
  //     this.blocking = false;
  //   } catch (error) {
  //     this.blocking = false;
  //     throw error;
  //   }
  // }

  async getSmsList(startDt, endDt) {
    try {
      this.blocking = true;
      this.startDt = startDt;
      this.endDt = endDt;
      this.list = [];
      smslist.map((item) => {
        this.addItem(item.loc, item.locname, item.url, startDt, endDt);
      });
    } catch (error) {
      this.blocking = false;
      throw error;
    }
  }

  async addItem(loc, locname, url, startDt, endDt) {
    try {
      let response = await axios.post(GET_SMS_LIST, {
        loc: loc,
        locNm: locname,
        url: url,
        startDt: startDt,
        endDt: endDt,
      });
      this.list.push(response.data);
      if (this.list.length == smslist.length) {
        this.blocking = false;
      }
    } catch (error) {
      this.list.push({ loc: loc, locname: locname, count: "error" });
      if (this.list.length == smslist.length) {
        this.blocking = false;
      }
    }
  }
}

decorate(Sms, {
  list: observable,
  startDt: observable,
  endDt: observable,
  blocking: observable,
  getSmsList: action,
  addItem: action,
});

const sms = new Sms();
export default sms;
